import React from "react";
import Typed from "react-typed";
import background from "../assets/background.gif";
import profileURL from "../assets/profile.jpeg";
import "../styles/profile.scss";

export default function Profile() {
  return (
    <div
      className={"wrapper"}
      style={{
        background: `url(${background}) no-repeat`,
      }}
    >
      <div className={"innerwrapper"}>
        <div className="profileWrapper">
          <div
            className="animate__animated animate__flip profileImage"
            style={{
              background: `url(${profileURL}) no-repeat`,
            }}
          ></div>
          <div className="animate__animated animate__fadeInBottomRight position">
            <div>Arvind S</div>
            <div>Front End Developer</div>
          </div>
        </div>
        <div className="animate__animated animate__fadeInLeft typer">
          <Typed
            strings={['"I code and know things..." - Arvind Suriya']}
            typeSpeed={80}
          />
        </div>
      </div>
    </div>
  );
}
